import module from 'module';
import _ from 'lodash';

const templateUrl = require('./organization.template.html');
module.component('organization', {
  templateUrl : templateUrl,
  controller: function ($scope, $location,  $timeout, authentication) {
    const $ctrl = this;

    $scope.permission = authentication.permissions;

    $scope.isActive = function(route) {
      return route === $location.path();
    }
    
    function activateTab(tabId) {
      if (!tabId) return;

      $timeout(function () {
        angular.element('a[data-target="#' + tabId + '"]').tab('show');
      });
    }
    $ctrl.activateTab = activateTab;

    // READ from URL
    function initTab() {
      var tab = $location.search().tab || 'tab_branches';
      $ctrl.activateTab(tab);
    }
    
    initTab();
  }
});

 